export default __webpack_public_path__ + "static/media/mobile_report-ioc.f5b9c893.png";